import CrudCustom from '../../../libs/custom/CrudCustom';

let DaftarNominatifPromosiService = new CrudCustom('/transaksi-beban-promosis');
export default DaftarNominatifPromosiService;
